export default {"src":"/_next/static/media/miota.2924736a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};